import { type VendorDocumentConstructor } from '../../entities/VendorDocument'
import { type VendorDocumentApiModel } from '../api-models/VendorDocumentApiModel'

export const mapVendorDocumentApiModel = (
  data: VendorDocumentApiModel
): VendorDocumentConstructor => ({
  uuid: data.uuid,
  name: data.name,
  file: data.file,
  mimetype: data.mimetype,
  createdAt: data.created_at,
})
